module.exports = __webpack_public_path__ + "static/media/video_05.e8054430.jpg";